export class RefreshableProperties {
  constructor(
    public key: string = '',
    public value: string = '',
  ) { }
}
